import { render, staticRenderFns } from "./wallet-switching-setting.vue?vue&type=template&id=497f1e72"
import script from "./wallet-switching-setting.vue?vue&type=script&lang=js"
export * from "./wallet-switching-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports